import urlJoin from 'url-join';
import { TenantId } from './tenant';

interface ApplicationSettings {
  caseSearchEnabled: boolean;
  caseRegisterEnabled: boolean;
  feedbackConversationLoggingEnabled: boolean;
  synergiLifeCaseUrl: string;
  oidcServiceUrl: string;
  oidcClientId: string;
  oidcScope: string;
  oidcDefaultProviderId: string;
  allowedOverrideDefaultOidcProviderIds: string[];
  reportBugUrl: string;
  welcomeMessage: string;
  sampleQuestions: Question[];
}

interface Question {
  question: string;
  caseSearch: boolean;
  caseRegistration: boolean;
}

const applicationSettings: Partial<ApplicationSettings> = {};

export async function fetchApplicationSettings(): Promise<void> {
  const response = await fetch(
    urlJoin(import.meta.env.VITE_API_URL || '', '/api/tenantconfig', TenantId)
  );
  if (!response.ok) {
    throw new Error('Failed to fetch application settings');
  }

  try {
    const fetchedSettings = (await response.json()) as Partial<ApplicationSettings>;
    Object.assign(applicationSettings, fetchedSettings);
  } catch {
    throw new Error('Failed to read application settings');
  }
}

export default applicationSettings as Readonly<ApplicationSettings>;
